<template>
  <component
    :is="`h${block.content.level || 2}`"
    v-html="block.content.text"
    class="block-heading"
  />
</template>

<script setup>
defineProps(['block'])
</script>

<style scoped>
.block-heading { margin-bottom: 1em; }
</style>
